<template>
  <div class="chat-modal">
  <form @submit.prevent="handleSubmit">
    <v-row
        class="ma-0 pa-0"
      >
      <v-col
        cols="12"
        sm="11"
        class="ma-0 pa-0"
      >
        <input
          id="username"
          class="username-input"
          autofocus
          type="text"
          name="userId"
          style="width:100%;height:35px;border:1px solid #ccc;padding-left:10px"
          placeholder="What is your name?"
          :value="username"
          @input="handleInput"
        />
      </v-col>
      <v-col
        cols="12"
        sm="1"
        class="ma-0 pa-0"
      >
        <button type="submit" class="submit-btn" style="height:35px;padding-left:10px">
          <v-icon>mdi-send</v-icon>
        </button>
      </v-col>
      </v-row>
  </form>
  </div>
</template>

<script>
export default {
  name: 'ChatModal',
  props: {
    username: String,
  },
  methods: {
    handleSubmit() {
      this.$emit('submit-username', this.username);
    },
    handleInput(event) {
      const { name, value } = event.target;
      this.$emit('update-input', name, value);
    }
  }
}
</script>